__turbopack_context__.v({
  "footerContent": "FooterList-module-scss-module__oaSdjW__footerContent",
  "footerHeading": "FooterList-module-scss-module__oaSdjW__footerHeading",
  "footerNav": "FooterList-module-scss-module__oaSdjW__footerNav",
  "listingsFooter": "FooterList-module-scss-module__oaSdjW__listingsFooter",
});
